import { ButtonContainer } from "./index.styled";


interface ButtonProps {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  color?: string;
  type?: "submit" | "button" | "reset";
}
const ButtonComponent: React.FC<ButtonProps> = ({ text, onClick, disabled, color='gray', type='button' }) => {
  return (
    <ButtonContainer 
      type={type}
      onClick={onClick} 
      disabled={disabled} 
      color={color}
    >
      {text}
    </ButtonContainer>
  )
};

export default ButtonComponent;
